import { Grid, Box, Button } from '@mui/material';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';

const SHOW_ALL_THRESHOLD = 5;

const ClusterOptionsList = ({
  items,
  totalCount,
  isAllVisible,
  onShowAll,
  sxStyle,
  boxRef,
  idPrefix,
  children,
}) => {
  return (
    <>
      <Box
        ref={boxRef}
        id={idPrefix && `${idPrefix}-opciones`}
        sx={{
          borderRadius: '8px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          ...(isAllVisible ? sxStyle.isScroll : {}),
        }}
      >
        {items.map(children)}
      </Box>
      {totalCount > SHOW_ALL_THRESHOLD && (
        <Grid item xs={12}>
          <Button
            id={idPrefix && `${idPrefix}-ver-todas`}
            sx={{
              ...sxStyle.compartirButton,
              ...(isAllVisible && sxStyle.visibility),
            }}
            onClick={onShowAll}
          >
            <FormatLineSpacingIcon sx={{ mr: '8px' }} />
            Ver todos
          </Button>
        </Grid>
      )}
    </>
  );
};

export default ClusterOptionsList;
